import React, { useState, useEffect } from 'react';
import { Avatar, Button, Form, Checkbox } from 'antd';
import {
  UserOutlined,
} from '@ant-design/icons';

import './style';

export default React.forwardRef((props, ref) => {
  const { onChange, creater, owner, user, onDelete, permissions } = props;
  return (
    <div className="permission-container">
      <div className="user">
        <Avatar icon={<UserOutlined />} />
        &nbsp;
        <div>
          <div><strong>{user.name}</strong></div>
          <div><small>{creater ? <a>(创建者)</a> : owner ? <a>(对接用户)</a> : undefined}</small></div>
        </div>
      </div>

        {(permissions || []).map((item) => (
          <Checkbox
            onChange={(e) => onChange(e.target.checked, user.id, item.id)}
            checked={(creater === true) ? true : user.permissions.find(x => x.permission_id === item.id)}
            disabled={creater}
            key={item.id}
            value={item.id}
          >
            {item.name}
          </Checkbox>
        ))}
      {
        onDelete && <Button danger onClick={onDelete}>
          删除
      </Button>
      }
    </div>
  );
});
